import * as types from '../constants/ActionTypes'

const chatsimult = (state = [], action) => {
    switch (action.type) {
      case types.CHAT_SIMULT:
      let temp = state.filter(todo => todo.iduserout === action.iduserout)
      if(temp.length === 0){
        return [
          ...state,
          {
              iduserout: action.iduserout,
              id: action.id,
              agent: action.agent,
              active: action.active,
              iduser: action.iduserout,
              voz: action.opencall,
              ramal: action.ramal,
              dateinit:action.dateinit,
              line:action.line
          }
        ]
      }else{
        return state
      }
      case types.EDIT_CHAT_SIMULT:
          return state.map(chat =>
            parseInt(chat.iduserout) === parseInt(action.iduserout) ?
            { 
              ...chat,
              qtdmsg: action.qtdmsg,
              atual: action.atual,
            } :
            chat
          )

          case types.EDIT_CHAT_SIMULT_ATENDIMENTO:
            return state.map(chat =>
              parseInt(chat.ramal) === parseInt(action.ramal) ?
              { 
                ...chat,
                atendimento: action.atendimento
              } :
              chat
            )


      case types.EDIT_CHAT_VOZ:
            return state.map(chat =>
              parseInt(chat.iduserout) === parseInt(action.iduserout) ?
              { 
                ...chat,
                active: action.active,
                voz: action.opencall,
                dateinit:action.dateinit,
                line:action.line,
                atendimento:false,
              } :
              chat
            )
      case types.EDIT_CHAT_VOZ_LINE:
          return state.map(chat =>
           // parseInt(chat.line) === parseInt(action.line) ?
            (parseInt(action.line) === parseInt(chat.line)) && (chat.line!== undefined) && (chat.line!== "undefined") ?
            { 
              ...chat,
              voz: false,
              dateinit:action.dateinit,
              line:0,
              atendimento:false
            } :
            chat
          )
      case types.CHAT_DEL:
      return state.filter(chat =>
        !chat.voz ? chat.iduserout !== action.iduserout : chat
      )     

      default:
        return state
    }
  }
  
  export default chatsimult